import { useCallback } from 'react';
import {
	DocumentType,
	useLazyMedicalHistoryDocumentQuery,
	useLazyMedicalHistoryDocumentsQuery,
} from '../../../graphql/graphql';
import { latestMedicalHistoryVersion } from '../Services/medicalHistory.service';

/**
 * Loads the current version of the patient's anamnesis document. `document(type: MEDICAL_HISTORY)`
 * returns the first document of the version chain, the current one is looked up among its versions.
 */
export default function useLoadMedicalHistoryDocument() {
	const [getMedicalHistoryDocument] = useLazyMedicalHistoryDocumentQuery();
	const [getMedicalHistoryDocuments] = useLazyMedicalHistoryDocumentsQuery();

	return useCallback(
		async (patientOriginalId: string) => {
			const { data } = await getMedicalHistoryDocument({
				patientId: patientOriginalId,
			});
			const document = data?.document;
			if (!document) {
				return undefined;
			}
			const versions = await getMedicalHistoryDocuments({
				where: { id: document.id, type: DocumentType.MedicalHistory },
			});
			return (
				latestMedicalHistoryVersion(versions.data?.documentVersions?.data) ??
				document
			);
		},
		[getMedicalHistoryDocument, getMedicalHistoryDocuments],
	);
}
